export default "__VITE_ASSET__15S_4eUo__"